<template>
    <div class="center_order_status_box">
        <!-- 标题 -->
        <center-title>{{$t("message.costatus.title")}}</center-title>
        <!-- 标签页 -->
       <order-search
            :tabs="power.includes(111)?tabs2:tabs1"
            :handle-download="handleOrderStatusExcel"
			@handle-export="conditionsExport"
			handle="/index/orderstatus/order_excel"
            @handle-search="getData(sortAttr, sortMode)">
        </order-search>
        <!-- 表格部分 -->
        <order-status-table
		
            :get-detail="getOrderStatusDetail"
            :prop-attr="sortAttr"
            :order="sortMode"
            :current-page="page.current_page"
            :page-count="page.last_page"
			@selection-change="handleSelectionChange"
			@handle-export="conditionsExport"
            @handleSort="handleSort"
            @current-change="handleCurrent">
        </order-status-table>
        <!-- 模态框 -->
        <order-status-dialog></order-status-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { tableRouterView } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableRouterView ],
    data() {
        return {
            tabs1: [ // 标签页参数
                {
                    label: this.$t("message.costatus.tabs1"),
                    name: "9",
                },
                {
                    label: this.$t("message.costatus.tabs2"),
                    name: "0",
                },
                {
                    label: this.$t("message.costatus.tabs3"),
                    name: "1",
                },
                {
                    label: this.$t("message.costatus.tabs4"),
                    name: "2",
                },
                {
                    label: this.$t("message.costatus.tabs5"),
                    name: "3",
                },
                {
                    label: this.$t("message.costatus.tabs6"),
                    name: "4",
                },
                // {
                //     label: this.$t("message.costatus.tabs7"),
                //     name: "5",
                // },
                // {
                //     label: this.$t("message.costatus.tabs8"),
                //     name: "6",
                // },
                {
                    label: this.$t("message.costatus.tabs9"),
                    name: "7",
                },
            ],
            tabs2: [ // 个人标签页参数
                {
                    label: this.$t("message.costatus.tabs1"),
                    name: "9",
                },
                {
                    label: this.$t("message.costatus.tabs6"),
                    name: "4",
                },
                {
                    label: this.$t("message.costatus.tabs7"),
                    name: "5",
                },
                {
                    label: this.$t("message.costatus.tabs8"),
                    name: "6",
                },
                {
                    label: this.$t("message.costatus.tabs9"),
                    name: "7",
                },
            ],
        }
    },
    computed: mapState({
        power: state => state.user.power,
        islogin: state => state.user.islogin,
        character_id: state => state.user.character_id,
        order_tabs: state => state.order.order_tabs,
        page: state => state.user.page
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        orderSearch: () => import("@/components/center/orderSearch"),
        orderStatusTable: () => import("@/components/center/orderStatusTable"),
        orderStatusDialog: () => import("@/components/center/orderStatusDialog"),
    },
    methods: {
        ...mapMutations([
            "setOrderList",
            "setOrderTabs",
            "handleDialog",
            'setPage'
        ]),
        ...mapActions([
            "getOrderDepartment",
            "getOrderStatusList",
            "handleOrderStatusExcel",
            "getOrderStatusDetail"
        ]),
		//按条件导出
		conditionsExport(){
			let order_sn = sessionStorage.getItem('order_sn') || '',
			    release = sessionStorage.getItem('release') || '',
			    relend = sessionStorage.getItem('relend') || '',
			    department = sessionStorage.getItem('department') || '',
			    user_id = sessionStorage.getItem('member') || '',
			    status = '',
			    orstatus = '';
			
			let list = this.selectedList.map(element => {
				return element.order_id
			});
			let id = list.join();
			let url = this.$URL.baseUrl + "index/orderstatus/order_excel?lang=cn&order_id=" + id + '&order_sn=' + order_sn + '&release=' + release + '&relend=' + relend + '&department=' + department + '&user_id=' +  user_id;                        
			console.log(url)
			window.open(url);
		},
		//導出选择订单导出
		handleExport() {
			let list = this.selectedList.map(element => {
				return element.order_id
			});
			if (list.length == 0) {
				this.$message({
					showClose: true,
					message: '請選擇導出訂單',
					type: "error"
				})
				return
			}
			let id = list.join();
			let url = this.$URL.baseUrl + "index/orderstatus/order_excel?lang=cn&order_id=" + id;
			window.open(url);
		},
        getData(attr, mode, page = 1) {
            let order_sn = sessionStorage.getItem('order_sn') || '',
                release = sessionStorage.getItem('release') || '',
                relend = sessionStorage.getItem('relend') || '',
                department = sessionStorage.getItem('department') || '',
                user_id = sessionStorage.getItem('member') || '',
                status = '',
                orstatus = '';
            
            switch (this.order_tabs){
                case '0':
                    status = 0;
                    break;
                case '1':
                    status = 1;
                    break;
                case '2':
                    orstatus = 6;
                    break;
                case '3':
                    status = 2;
                    break;
                case '4':
                    orstatus = 3;
                    break;
                case '5':
                    orstatus = 2;
                    break;
                case '6':
                    orstatus = 1;
                    break;
                case '7':
                    orstatus = 7;
                    break;
            }
            
            this.getOrderDepartment();
            this.getOrderStatusList({
                order_sn,
                release,
                relend,
                department,
                user_id,
                status,
                orstatus,
                attr,
                mode,
                page
            })
        },
        changeRouter(search, attr, mode, page = 1) {
            this.$router.push({
                name: 'orderStatus',
                query: {
                    attr,
                    mode,
                    page
                }
            }).catch(err => err)
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            // let allow = vm.character_id !== 5 && vm.character_id !== 6,
			setTimeout(() => {
				let allow = vm.power.includes(0) ||  vm.power.includes(11) ||  vm.power.includes(111),
				    {
				        attr = '',
				        mode = '',
				        page = 1
				    } = to.query;
				if(allow){
				    vm.getData(attr, mode, page);
				}else{
				    vm.$message({
				        showClose: true,
				        message: vm.$t("message.costatus.errmsg1"),
				        type: "error"
				    })
				    vm.$router.back();
				    return false;
				}
			}, 500)
        })
    },
    beforeRouteUpdate(to, from, next) {
        let {
            attr = '',
            mode = '',
            page = 1
        } = to.query;
        
        this.getData(attr, mode, page);
        next();
    },
    beforeRouteLeave (to, from, next) {
        this.setOrderTabs("9");
        this.setOrderList([]);
        this.setPage({});
        this.handleDialog(false);
        sessionStorage.removeItem("order_tabs");
        sessionStorage.removeItem("order_sn");
        sessionStorage.removeItem("release");
        sessionStorage.removeItem("relend");
        sessionStorage.removeItem("department");
        sessionStorage.removeItem("member");
        next();
    }
}
</script>